/* ============================================================================
   pers-koszyk.js — zachowanie pływającej ikony i szuflady koszyka.

   ── JEDNO ŹRÓDŁO STANU ────────────────────────────────────────────────────
   Skrypt NIE trzyma własnej liczby sztuk, własnej sumy ani własnej listy
   pozycji. Każda zmiana kończy się pobraniem świeżego HTML-a sekcji przez
   Section Rendering API (`?sections=<id>`) i podmianą zawartości. Licznik
   na ikonie, pasek postępu i suma są renderowane przez Liquid z `cart`,
   więc nie mogą się rozjechać z koszykiem — bo są koszykiem.

   To ta sama zasada, którą trzymaliśmy przy ilości na pasku podążającym:
   stan mieszka w jednym miejscu, reszta go czyta.

   ── CZEGO NIE ROBI ────────────────────────────────────────────────────────
   - nie buduje własnych przycisków portfeli (renderuje je Shopify),
   - nie przechwytuje `submit` formularza kasy,
   - nie usuwa `<cart-notification>` — popup motywu zostaje w DOM,
     szuflada przejmuje rolę zachowaniem, nie wyrwaniem węzła.
   ============================================================================ */

(function () {
  'use strict';

  var KORZEN = document.getElementById('pers-koszyk');
  if (!KORZEN) return;

  var panel = document.getElementById('pers-koszyk__panel');
  var overlay = document.getElementById('pers-koszyk__overlay');
  var ikona = document.getElementById('pers-koszyk__ikona');
  var zamknij = document.getElementById('pers-koszyk__zamknij');
  if (!panel || !overlay || !ikona) return;

  var poprzedniFokus = null;

  /* ------------------------------------------------ otwieranie i zamykanie */

  function elementyFokusowalne() {
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(function (e) { return e.offsetParent !== null; });
  }

  function otworz() {
    if (KORZEN.dataset.otwarty === 'true') return;
    poprzedniFokus = document.activeElement;
    KORZEN.dataset.otwarty = 'true';
    ikona.setAttribute('aria-expanded', 'true');
    // `inert` zdejmujemy PRZED szukaniem fokusu — w panelu inertnym nie ma
    // czego fokusować i fokus wylądowałby na `<body>`.
    panel.removeAttribute('inert');
    // Tło nie przewija się pod otwartą szufladą.
    document.documentElement.style.overflow = 'hidden';
    var pierwszy = elementyFokusowalne()[0];
    (pierwszy || panel).focus();
  }

  function zamknijPanel() {
    if (KORZEN.dataset.otwarty !== 'true') return;
    KORZEN.dataset.otwarty = 'false';
    ikona.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    // Fokus wraca tam, skad przyszedl — inaczej czytnik ekranu ladowalby
    // na poczatku dokumentu. WYPROWADZAMY fokus, zanim panel stanie sie
    // inertny: inert na elemencie trzymajacym fokus zostawia dokument bez
    // aktywnego elementu i klawiatura zaczyna od poczatku strony.
    if (poprzedniFokus && poprzedniFokus.focus) poprzedniFokus.focus();
    else ikona.focus();
    panel.setAttribute('inert', '');
  }

  ikona.addEventListener('click', function () { otworz(); dociagnijDobierz(); });
  overlay.addEventListener('click', zamknijPanel);
  if (zamknij) zamknij.addEventListener('click', zamknijPanel);

  document.addEventListener('keydown', function (e) {
    if (KORZEN.dataset.otwarty !== 'true') return;

    if (e.key === 'Escape') { zamknijPanel(); return; }

    // PUŁAPKA FOKUSU. Tab na ostatnim elemencie wraca na pierwszy i odwrotnie —
    // bez tego klawiatura wychodzi za szufladę, która wizualnie przykrywa stronę.
    if (e.key !== 'Tab') return;
    var lista = elementyFokusowalne();
    if (!lista.length) return;
    var pierwszy = lista[0], ostatni = lista[lista.length - 1];
    if (e.shiftKey && document.activeElement === pierwszy) { e.preventDefault(); ostatni.focus(); }
    else if (!e.shiftKey && document.activeElement === ostatni) { e.preventDefault(); pierwszy.focus(); }
  });

  /* ------------------------------------------------ odswiezanie z sekcji */

  function podmien(html) {
    var pomocniczy = document.createElement('div');
    pomocniczy.innerHTML = html;
    var nowy = pomocniczy.querySelector('#pers-koszyk');
    if (!nowy) return false;

    var byloOtwarte = KORZEN.dataset.otwarty === 'true';

    // Podmieniamy WNETRZE panelu i licznik, a nie cały korzeń: korzeń niesie
    // stan otwarcia i nasłuchy, więc jego wymiana kasowałaby jedno i drugie.
    var noweTresc = nowy.querySelector('#pers-koszyk__tresc');
    var nowaStopka = nowy.querySelector('#pers-koszyk__stopka');
    var nowyLicznik = nowy.querySelector('#pers-koszyk__licznik');

    var tresc = document.getElementById('pers-koszyk__tresc');
    if (tresc && noweTresc) tresc.innerHTML = noweTresc.innerHTML;

    var stopka = document.getElementById('pers-koszyk__stopka');
    if (stopka && nowaStopka) stopka.innerHTML = nowaStopka.innerHTML;
    else if (stopka && !nowaStopka) stopka.remove();
    else if (!stopka && nowaStopka) panel.appendChild(nowaStopka);

    var licznik = document.getElementById('pers-koszyk__licznik');
    if (licznik && nowyLicznik) {
      licznik.textContent = nowyLicznik.textContent;
      licznik.hidden = nowyLicznik.hasAttribute('hidden');
    }

    KORZEN.dataset.sztuk = nowy.dataset.sztuk || '0';
    KORZEN.dataset.otwarty = byloOtwarte ? 'true' : 'false';
    return true;
  }

  function odswiez() {
    var sekcja = KORZEN.dataset.sekcja;
    if (!sekcja) return Promise.resolve(false);
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sekcja),
                 { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (dane) { return podmien(dane[sekcja] || ''); })
      .catch(function () { return false; });
  }

  /* ------------------------------------------------ zmiana ilosci i usuwanie */

  function zmien(linia, ilosc) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: linia, quantity: ilosc }),
    })
      .then(function (r) { return r.json(); })
      // Stan bierzemy z sekcji, nie z odpowiedzi: to ten sam Liquid, ktory
      // renderuje koszyk, wiec nie ma dwoch wersji prawdy o zawartosci.
      .then(function () { return odswiez(); });
  }

  panel.addEventListener('click', function (e) {
    var pozycja = e.target.closest ? e.target.closest('.pers-koszyk__pozycja') : null;
    if (!pozycja) return;
    var linia = parseInt(pozycja.dataset.linia, 10);
    if (!isFinite(linia)) return;

    if (e.target.hasAttribute('data-usun')) {
      e.preventDefault();
      zmien(linia, 0);
      return;
    }

    var krok = e.target.getAttribute('data-krok');
    if (krok === null) return;
    e.preventDefault();
    var liczba = pozycja.querySelector('.pers-koszyk__liczba');
    var teraz = liczba ? parseInt(liczba.textContent, 10) : 1;
    if (!isFinite(teraz)) teraz = 1;
    var docelowo = Math.max(0, teraz + parseInt(krok, 10));
    zmien(linia, docelowo);
  });

  /* ------------------------------------------------ karuzela „Dobierz" */

  // LENIWIE: dopiero po otwarciu szuflady i tylko raz na otwarcie. Karuzela
  // przegląda `related_products` wszystkich pozycji — to kilkadziesiąt odczytów
  // produktów, których nie wolno wrzucać w moment dodawania do koszyka.
  var dobieranieWToku = false;

  function dociagnijDobierz() {
    var gniazdo = document.getElementById('pers-koszyk__dobierz');
    if (!gniazdo || dobieranieWToku) return;
    var sekcja = gniazdo.dataset.sekcja;
    if (!sekcja) return;
    dobieranieWToku = true;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sekcja),
          { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (dane) {
        var html = dane[sekcja] || '';
        var pom = document.createElement('div');
        pom.innerHTML = html;
        var srodek = pom.querySelector('#pers-dobierz');
        gniazdo.innerHTML = srodek ? srodek.innerHTML : '';
      })
      .catch(function () { /* brak karuzeli nie moze psuc koszyka */ })
      .finally(function () { dobieranieWToku = false; });
  }

  // Dodanie z kafla: tylko produkty jednowariantowe maja przycisk, wiec nie ma
  // tu zadnego zgadywania wariantu. Po dodaniu odswiezamy szuflade — i zostaje
  // OTWARTA, bo `odswiez` podmienia wnetrze, nie korzen.
  panel.addEventListener('click', function (e) {
    var plus = e.target.closest ? e.target.closest('.pers-dobierz__plus') : null;
    if (!plus || !plus.dataset.wariant) return;
    e.preventDefault();
    plus.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      // `X-Pers-Wlasne` mowi nasluchowi nizej, zeby to dodanie przepuscil bez
      // ogloszenia: obsluge mamy TU, w lancuchu ponizej. Bez tej pieczatki to
      // samo dodanie odswiezaloby sekcje dwa razy.
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Pers-Wlasne': '1' },
      body: JSON.stringify({ id: plus.dataset.wariant, quantity: 1 }),
    })
      .then(function () { return odswiez(); })
      .then(function () { dociagnijDobierz(); })
      .catch(function () { plus.disabled = false; });
  });

  /* ------------------------------------------------ udostepnianie koszyka */

  panel.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('#pers-koszyk__udostepnij') : null;
    if (!btn) return;
    e.preventDefault();
    var link = btn.dataset.link || '';
    var toast = document.getElementById('pers-koszyk__toast');
    var pokazToast = function () {
      if (!toast) return;
      toast.hidden = false;
      setTimeout(function () { toast.hidden = true; }, 3000);
    };

    // `navigator.clipboard` wymaga bezpiecznego kontekstu i bywa odmawiane.
    // Zapas: pole tekstowe i `execCommand`. Bez zapasu przycisk milczalby
    // w przegladarkach, ktore odmowily uprawnienia — a klient nie wiedzialby,
    // czy skopiowalo, czy nie.
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link).then(pokazToast, function () { zapas(link, pokazToast); });
    } else {
      zapas(link, pokazToast);
    }
  });

  function zapas(tekst, potem) {
    var pole = document.createElement('textarea');
    pole.value = tekst;
    pole.setAttribute('readonly', '');
    pole.style.position = 'fixed';
    pole.style.opacity = '0';
    document.body.appendChild(pole);
    pole.select();
    try { document.execCommand('copy'); potem(); } catch (e) { /* trudno */ }
    document.body.removeChild(pole);
  }

  /* ------------------------------------------------ auto-otwarcie po dodaniu */

  // Slucha FAKTU ogloszonego przez `product-form.js`. Ten plik nie wie
  // o szufladzie, a szuflada nie podmienia niczego w nim.
  //
  // ODSIEW POWTORZEN. Od kiedy fakt dodania ma DWA zrodla (ogloszenie
  // z product-form i nasluch nizej), to samo dodanie potrafi zglosic sie
  // dwa razy — a kazde zgloszenie to osobne odswiezenie sekcji. Okno 800 ms
  // zbiera je w jedno: otwarcie szuflady jest bezpieczne przy powtorzeniu,
  // ale drugi przejazd po sieci juz nie jest darmowy.
  var ostatnieDodanie = 0;

  document.addEventListener('pers:koszyk-dodano', function () {
    var teraz = Date.now();
    if (teraz - ostatnieDodanie < 800) return;
    ostatnieDodanie = teraz;
    odswiez().then(function () {
      if (KORZEN.dataset.auto === 'true') otworz();
      dociagnijDobierz();
    });
  });

  /* ------------------------------------------------ nasluch /cart/add */

  // DRUGIE ZRODLO FAKTU, nie druga sciezka dodawania. Ogloszenie z
  // `product-form.js` obejmuje tylko formularze motywu. Aplikacja albo obcy
  // skrypt, ktory doda pozycje wlasnym `fetch`/XHR, nie powie nam nic —
  // i szuflada zostanie z nieaktualnym koszykiem.
  //
  // CZEGO TO NIE ZALATWIA: kalkulatora CPC. Aplikacja ma wylaczony nowy
  // przeplyw (`cpc_isNewCheckoutFlowEnabled = false`) i dodaje pozycje
  // PELNYM POST-em formularza z przekierowaniem na /cart — zmierzone na
  // podgladzie. Nawigacji nie da sie podsluchac, bo dokument ginie razem
  // z nasluchem; klient laduje na stronie koszyka i tam widzi swoja pozycje.
  //
  // Oplatamy, nie zastepujemy: oryginal dostaje te same argumenty i to samo
  // `this`, a jego wynik wraca nietkniety. Kazdy nasz dodatek siedzi w
  // try/catch, bo blad w podgladaniu nie moze wywrocic dodawania do koszyka.
  function toDodanie(url, metoda) {
    return String(metoda || 'GET').toUpperCase() === 'POST' &&
           /\/cart\/add(\.js)?(\?|$)/.test(String(url || '').split('#')[0]);
  }
  // Nasze wlasne dodanie (kafel „Dobierz") ma juz swoj lancuch obslugi —
  // nasluch ma je przepuscic, zeby sekcja nie odswiezala sie dwa razy.
  function nasze(opcje) {
    try {
      var h = opcje && opcje.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return !!h.get('X-Pers-Wlasne');
      return !!(h['X-Pers-Wlasne'] || h['x-pers-wlasne']);
    } catch (e) { return false; }
  }
  function ogloszDodanie() {
    try {
      document.dispatchEvent(new CustomEvent('pers:koszyk-dodano', { detail: { zrodlo: 'nasluch' } }));
    } catch (e) { /* stary IE-owy CustomEvent — trudno, szuflada odswiezy sie przy otwarciu */ }
  }

  var oryginalnyFetch = window.fetch;
  if (typeof oryginalnyFetch === 'function') {
    window.fetch = function (zasob, opcje) {
      var wynik = oryginalnyFetch.apply(this, arguments);
      try {
        var url = (zasob && zasob.url) || zasob;
        var metoda = (opcje && opcje.method) || (zasob && zasob.method) || 'GET';
        if (toDodanie(url, metoda) && !nasze(opcje) && wynik && typeof wynik.then === 'function') {
          wynik.then(function (odp) { if (odp && odp.ok) ogloszDodanie(); }, function () {});
        }
      } catch (e) { /* nie nasze zadanie — przepuszczamy bez sladu */ }
      return wynik;
    };
  }

  var oryginalnyOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var oryginalnySend = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  if (oryginalnyOpen && oryginalnySend) {
    window.XMLHttpRequest.prototype.open = function (metoda, url) {
      try { this.__persDodanie = toDodanie(url, metoda); } catch (e) {}
      return oryginalnyOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__persDodanie) {
          this.addEventListener('loadend', function () {
            if (this.status >= 200 && this.status < 300) ogloszDodanie();
          });
        }
      } catch (e) {}
      return oryginalnySend.apply(this, arguments);
    };
  }
})();
